<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        label-suffix=":"
        :label-position="'right'"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('BannerSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('BannerAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('BannerUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <!-- 			<el-button v-if="checkAuthActionAccess('BannerDel')" :size="size"  @click="del" icon="el-icon-remove-outline" :disabled="btn.delDisabled" >{{ $t('삭제') }}</el-button> -->
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        fixed
        label-class-name="data_cnt"></el-table-column>
      <el-table-column :label="$t('사용 설정')" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="setting(scope.row.bannerCd, 'Y')"
            style="width: 100px"
            v-if="'N' == scope.row.useYn"
            >{{ $t('사용') }}</el-button
          >
          <el-button size="mini" type="info" @click="setting(scope.row.bannerCd, 'N')" style="width: 100px" v-else>{{
            $t('사용중지')
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('배너 이미지')" prop="bannerImg" min-width="350" align="center">
        <template slot-scope="scope">
          <fallback-image
            style="width: 300px; height: 81px"
            :src="resolvImage(scope.row.bannerImg)"
            fit="fill"></fallback-image>
        </template>
      </el-table-column>
    </el-table>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" class="img_dialog">
      <el-form
        :model="inputForm"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-form-item :error="formError['bannerImgFile']" required>
          <el-upload
            action=""
            class="avatar-uploader"
            accept="image/*"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="imgChange">
            <fallback-image
              native
              v-if="inputForm.bannerImg || inputForm.bannerImgFile"
              :src="this.resolvImage(inputForm.bannerImgFile)"
              class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">{{ $t('300x81 픽셀 이미지만 업로드 가능합니다.') }}</div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/banner'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.closeDialogVisible = false
    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        useYn: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        bannerCd: null,
        bannerImg: '',
        bannerImgFile: '',
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        bannerImgFile: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].bannerCd
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()

      this.dialogFormVisible = true
      this.btn.saveDisabled = false

      this.inputForm.title = this.$t('배너 추가')
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.bannerCd,
        function (result) {
          result.statu = 'U'
          result.bannerImgFile = result.bannerImg
          result.title = this.$t('배너 수정')
          this.inputForm = result

          this.formError = this.initFormError()

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this)
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    setting: function (bannerCd, useYn) {
      this.mainVue
        .$confirm(
          'Y' == useYn
            ? this.$t('배너 이미지 사용으로 설정 하시겠습니까?')
            : this.$t('배너 이미지 사용중지 하시겠습니까?'),
          this.mainVue.appMsg.systemAlterTitle,
          {
            confirmButtonText: 'Y' == useYn ? this.$t('사용') : this.$t('사용중지'),
            cancelButtonText: this.$t('취소'),
            type: 'info',
          }
        )
        .then(
          function () {
            this.mainVue.$axios.patch(
              this.url + '/' + bannerCd + '/' + useYn,
              null,
              null,
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('설정 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('설정 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if (util.isEmpty(this.inputForm.bannerImgFile)) {
        this.formError.bannerImgFile = this.$t('배너 이미지를 선택 하여 주십시오.')
        return
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this)
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.bannerCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this)
        )
      }
    },
    // 이미지 선택
    imgChange: function (file) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data, img) {
          if (300 != img.width || 81 != img.height) {
            this.mainVue.$message({ type: 'warning', message: this.$t('300x81 픽셀 이미지만 업로드 가능합니다.') })
          } else {
            this.inputForm.bannerImgFile = data
          }
        }.bind(this)
      )
    },
  },
}
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 81px;
  line-height: 81px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 81px;
  display: block;
}

.img_dialog {
}

@media (max-width: 768px) {
  .img_dialog::v-deep > .el-dialog {
    width: 100%;
    max-width: 380px;
  }
}
</style>
